import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import TaskModalSidebar from 'bundles/apex/tasks/task_modal/sidebar';
import TaskModalStandard from 'bundles/apex/tasks/task_modal/standard';

export default function AddTask({
  asModal,
  className,
  createTask,
  displayAs,
  features,
  formDependenciesPath,
}) {
  const [showModal, setShowModal] = useState();
  const AddComponent = displayAs || AddControl;
  const taskModal = features.edgeCrm && !asModal
    ? (
      <TaskModalSidebar
        createTask={createTask}
        formDependenciesPath={formDependenciesPath}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    )
    : (
      <TaskModalStandard
        createTask={createTask}
        formDependenciesPath={formDependenciesPath}
        show={showModal}
        onHide={() => setShowModal(false)}
      />);

  return <React.Fragment>
    <AddComponent aria-label="Add task" className={className} onClick={() => setShowModal(true)}>
      Add task
    </AddComponent>

    {taskModal}
  </React.Fragment>;
}

AddTask.propTypes = {
  asModal: PropTypes.bool,
  className: PropTypes.string,
  createTask: PropTypes.func,
  displayAs: PropTypes.elementType,
  features: PropTypes.shape({
    edgeCrm: PropTypes.bool,
  }).isRequired,
  formDependenciesPath: PropTypes.string,
};
